/* eslint-disable class-methods-use-this */

const BYPASS_KEY = 'isBypass';

class LocalStorageService {
	get(key: string): string | null {
		if (typeof window === 'undefined') return null;
		try {
			return localStorage.getItem(key);
		} catch (error) {
			console.error('Error reading from localStorage:', error);
			return null;
		}
	}

	set(key: string, value: string): void {
		if (typeof window === 'undefined') return;
		try {
			localStorage.setItem(key, value);
		} catch (error) {
			console.error('Error writing to localStorage:', error);
		}
	}

	remove(key: string): void {
		if (typeof window === 'undefined') return;
		try {
			localStorage.removeItem(key);
		} catch (error) {
			console.error('Error removing from localStorage:', error);
		}
	}

	// Specific methods for isBypass
	getIsBypass(): boolean {
		const value = this.get(BYPASS_KEY);
		return value === 'true';
	}

	setIsBypass(value: boolean): void {
		this.set(BYPASS_KEY, value.toString());
	}

	removeIsBypass(): void {
		this.remove(BYPASS_KEY);
	}

	// Check both query parameter and localStorage
	checkIsBypass(queryParam?: string | string[]): boolean {
		// First check query parameter explicitly
		if (queryParam === 'true') {
			// Store in localStorage for future use
			this.setIsBypass(true);
			return true;
		}
		// If query param is explicitly 'false', remove from localStorage
		if (queryParam === 'false') {
			this.removeIsBypass();
			return false;
		}
		// If query param is undefined/not provided, check localStorage
		if (queryParam === undefined) {
			return this.getIsBypass();
		}
		// For any other value, return false
		return false;
	}
}

export default new LocalStorageService();
